import * as THREE from 'three';

import Debug from './Utils/Debug.js';
import Sizes from './Utils/Sizes.js';
import Time from './Utils/Time.js';
import Camera from './Camera.js';
import Renderer from './Renderer.js';
import World from './World/World.js';
import Resources from './Utils/Resources.js';
import Stats from 'three/examples/jsm/libs/stats.module.js';

import sources from './sources.js';

export default class Experience {
    static instance;

    static getInstance(_canvas) {
        return Experience.instance;
    }

    constructor(_canvas) {
        // Singleton
        if (Experience.instance) {
            return Experience.instance;
        }
        Experience.instance = this;

        // Options
        this.canvas = _canvas;

        // Setup
        this.debug = new Debug();
        this.sizes = new Sizes();
        this.time = new Time();
        this.scene = new THREE.Scene();
        this.resources = new Resources(sources);
        this.camera = new Camera();
        this.renderer = new Renderer();
        this.world = new World();

        // Resize event
        this.sizes.on('resize', () => {
            this.resize();
        });

        // Time tick event
        this.time.on('tick', () => {
            this.update();
        });

        // Stats
        if (this.debug.active) {
            this.stats = new Stats();
            document.body.appendChild(this.stats.dom);
        }

        //Fullscreen
        const fullscreenBtn = document.getElementById("fullscreen-btn");
        const footer = document.querySelector(".footer"); // Selecting the footer

        fullscreenBtn.addEventListener("click", () => {
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen().then(() => {
                    footer.style.display = "none"; // Hide the footer
                    fullscreenBtn.textContent = "❌ Exit Fullscreen";
                });
            } else {
                document.exitFullscreen().then(() => {
                    footer.style.display = "flex"; // Show the footer again
                    fullscreenBtn.textContent = "🔲 Fullscreen";
                });
            }
        });


    }

    resize() {
        this.camera.resize();
        this.renderer.resize();
        this.world.resize();
    }

    update() {
        this.camera.update();
        this.world.update();
        this.renderer.update();

        if (this.debug.active)
            this.stats.update();
    }

    destroy() {
        this.sizes.off('resize');
        this.time.off('tick');

        // Traverse the whole scene
        this.scene.traverse((child) => {
            // Test if it's a mesh
            if (child instanceof THREE.Mesh) {
                child.geometry.dispose();

                // Loop through the material properties
                for (const key in child.material) {
                    const value = child.material[key];

                    // Test if there is a dispose function
                    if (value && typeof value.dispose === 'function') {
                        value.dispose();
                    }
                }
            }
        });

        this.camera.controls.dispose();
        this.renderer.instance.dispose();

        if (this.debug.active)
            this.debug.ui.destroy();
    }
}
